import { GETPAYMENTGETWAY, CREATELINK, SET_CASHFREE_ORDER_ID, SET_RAZORPAY_ORDER_ID ,SENDMAIL} from "../actions/types";

const initialState = {
  getAllPaymentGetwayList: [],
  createLink: null,
  cfOrderId: null,
  rzpOrderId: null,
  
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GETPAYMENTGETWAY:
      return {
        ...state,
        getAllPaymentGetwayList: action.payload.data,
      };
    case CREATELINK:
      return {
        ...state,
        createLink: action.payload,
      };
       case SENDMAIL:
      return {
        ...state,
        createMailLink: action.payload,
      };
    case SET_CASHFREE_ORDER_ID:
      console.log("✅ New cf_order_id stored in Redux:", action.payload);
      return {
        ...state,
        cfOrderId: action.payload,
      };
    case SET_RAZORPAY_ORDER_ID:
      console.log("✅ New rzp_order_id stored in Redux:", action.payload);
      return {
        ...state,
        rzpOrderId: action.payload,
      };
    default:
      return state;
  }
}
